import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzMicroactionModule } from '@blk/daisy/combinations/microactions';
import { DzPaginationModule } from '@blk/daisy/combinations/pagination';
import { DAISY_ICONS } from '@blk/daisy/core/icon';
import { DzCheckboxModule } from '@blk/daisy/elements/selection-controls';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { PortfolioDataModule } from '@ddt-web/portfolio-data';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { PortfolioTableComponent } from './portfolio-table.component';
import { PortfolioTableSkeletonComponent } from './skeleton/portfolio-table-skeleton.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		FormsModule,
		ReactiveFormsModule,
		MatTooltipModule,
		NgxSkeletonLoaderModule,
		AnalyticsModule,
		GenericDirectivesModule,
		DzCheckboxModule,
		DzMicroactionModule,
		PortfolioDataModule,
		DzPaginationModule
	],
	declarations: [
		PortfolioTableComponent,
		PortfolioTableSkeletonComponent
	],
	exports: [
		PortfolioTableComponent,
		PortfolioTableSkeletonComponent
	],
	providers: [
		{
			provide: DAISY_ICONS,
			useValue: [faTimes, faPlus],
			multi: true
		}
	]
})
export class PortfolioTableModule { }
